import React from "react";

const ECGWave = () => {
  return (
    <div className="ecg-container">
      <svg className="ecg-svg" viewBox="0 0 400 64" preserveAspectRatio="none">
        <path
          d="M0,32 L50,32 L60,10 L70,54 L80,32 L120,32 L130,20 L140,44 L150,32 L400,32"
          stroke="#10b981"
          strokeWidth="2"
          fill="none"
          className="ecg-line"
        />
      </svg>
    </div>
  );
};

export default ECGWave;
